import React from 'react'
import { useFormContext } from 'react-hook-form'
import { AnalyzerFormValues } from '../analyzerForm.types'
import ICSTextInput from '../../../../components/ICSSimpleTextInput/ICSTextInput'

interface Props {
  name: keyof AnalyzerFormValues
  label: string
  placeholder?: string
  maxLength?: number
}

const AnalyzerTextInput = (props: Props) => {
  const { control } = useFormContext<AnalyzerFormValues>()
  return <ICSTextInput {...props} control={control} />
}

export default AnalyzerTextInput
